import React from 'react';
import { useOutletContext } from 'react-router-dom';
import SectionLabel from '../components/SectionLabel';
import Icon from '../components/Icon';
import Skeleton, { EmptyState } from '../components/Skeleton';
import { fetchLocal, useLive } from '../data/live';

export default function LocalGuidePage() {
  const { meeting } = useOutletContext();
  const event = meeting._event;

  const local = useLive(fetchLocal, [event?.id]);

  if (local === undefined) return <Skeleton variant="card" count={4} />;
  if (!local) {
    return <EmptyState>Local dining and transportation tips will be posted here soon.</EmptyState>;
  }

  return (
    <>
      {local.Dining && local.Dining.length > 0 && (
        <>
          <SectionLabel right={`${local.Dining.length}`}>Dining</SectionLabel>
          <div className="portal-card-grid">
            {local.Dining.map((d, i) => (
              <div key={i} className="portal-local-card">
                <div className="portal-local-name">{d.name}</div>
                <div className="portal-local-desc">{d.desc}</div>
                {d.loc && (
                  <div className="portal-local-loc">
                    <Icon name="map-pin" size={13} className="portal-local-loc-marker" />
                    <span>{d.loc}</span>
                  </div>
                )}
                {d.url && (
                  <a className="portal-local-link" href={d.url} target="_blank" rel="noreferrer">
                    Visit site <Icon name="external-link" size={13} />
                  </a>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {local.transit && local.transit.length > 0 && (
        <>
          <SectionLabel right={`${local.transit.length}`}>Getting around</SectionLabel>
          <div className="portal-card-grid">
            {local.transit.map((t, i) => (
              <div key={i} className="portal-local-card">
                <div className="portal-local-name">{t.title}</div>
                <div className="portal-local-desc">{t.desc}</div>
                {t.url && (
                  <a className="portal-local-link" href={t.url} target="_blank" rel="noreferrer">
                    Visit site <Icon name="external-link" size={13} />
                  </a>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
